import React, { useEffect, useState } from "react";
import StickyBox from "react-sticky-box";
import ProjectSavedSearchesHeader from "./ProjectSavedSearchesHeader";
import ProjectSavedSearchesSecondHeader from "./ProjectSavedSearchesSecondHeader";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getProjectDetail } from "api/project.api";
import { setSelectedProjectData } from "store/slices/projectSlice";
import { RootState } from "store/store";
import { error } from "console";
import { message } from "antd";

interface LayoutProps {
  children: React.ReactNode; // Define children prop to accept nested content
}

const ProjectHeaderLayouts: React.FC<LayoutProps> = ({ children }) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const numberId = Number(id);
  const [state, setState] = useState<string>('');
  const selectedProject = useSelector((state: RootState) => state.projectSlice.update_project);
  const triggerProjectDetailChanges = useSelector((state: any) => state.talentPool.triggerProjectDetailRefresh);

  const getProjectDetails = async (id: number) => {
    if (numberId != null) {
      try {
        const response = await getProjectDetail(id);
        if (response) {
          dispatch(setSelectedProjectData(response));
      }
      } catch(error){
        console.log("Error: ", error);
        message.error("Somthing went wrong, Project Not Found!");
      }
    }
  };

  useEffect(() => {
    getProjectDetails(numberId);
  }, [numberId, state, selectedProject, triggerProjectDetailChanges]);

  const [previousIndex, setPreviousIndex] = useState<number[]>([]);
  const [currentIndex, setCurrentIndex] = useState<number>(1);

   // Function to add (push) a tab number to the history
   const addTab = (tabNumber: number) => {
    setPreviousIndex((prev) => [...prev, tabNumber]);
  };

  // Function to remove (pop) the last tab number from the history
  const popTab = () => {
    setPreviousIndex((prev) => prev.slice(0, -1));
  };

  const getLastTab = () => {
    return previousIndex.length > 0 ? previousIndex[previousIndex.length - 1] : null;
  };

  return (
    <div className="w-reduce-sidebar ml-auto bg-utility-Grayblue">
      <StickyBox offsetTop={73} className="z-[1]">
        <ProjectSavedSearchesHeader selectedPool={numberId} popTab={popTab} getLastTab={getLastTab} currentIndex={currentIndex} setCurrentIndex={setCurrentIndex} setState={setState}/>
        <ProjectSavedSearchesSecondHeader selectedPool={numberId} addTab={addTab} currentIndex={currentIndex} setCurrentIndex={setCurrentIndex}/>
      </StickyBox>
      { children }
    </div>
  );
};

export default ProjectHeaderLayouts;
